import Shipment from 'interfaces/PmParcel';
import { CarrierInformation } from 'components/MerchantTrackingWidget/components/CarrierInformation';
import { TrackingDetailsHeader } from 'components/MerchantTrackingWidget/components/TrackingDetailsHeader';
import { MainInfo } from './components/MainInfo';
import { ProgressIndicator } from './components/ProgressIndicator';
import {
  Container,
  MainInfoContainer,
  ProgressIndicatorContainer,
} from './TrackingDetails.styles';
import { ReturnShipment } from '../../models/ReturnShipment.model';

interface TrackingDetailsProps {
  shipment: Shipment;
  hasMultipleShipments: boolean;
  shouldShowProgressIndicator?: boolean;
  type: 'full' | 'preprinted';
}

export const TrackingDetails = ({
  shipment: baseShipment,
  hasMultipleShipments,
  shouldShowProgressIndicator,
  type,
}: TrackingDetailsProps) => {
  const returnShipment = ReturnShipment.create(baseShipment, {
    partial: false,
  });

  return (
    <Container>
      <TrackingDetailsHeader
        shipment={baseShipment}
        hasMultipleShipments={hasMultipleShipments}
      />

      <ProgressIndicatorContainer>
        {shouldShowProgressIndicator && (
          <ProgressIndicator type={type} shipment={returnShipment} />
        )}
      </ProgressIndicatorContainer>

      <MainInfoContainer>
        <MainInfo shipment={baseShipment} />
      </MainInfoContainer>

      <CarrierInformation />
    </Container>
  );
};
